



















import Vue from 'vue'
import { eventDelegatorFactory } from '@/utils'

let idSequence = 0

export default Vue.extend({
  props: {
    id: {
      type: String,
    },
    accordionGroup: {
      type: String,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
  },
  computed: {
    _delegatePropsToCollapse(): object {
      return {
        id: this.uniqueId,
        accordion: this.accordionGroup,
      }
    },
    _delegateListenersFromCollapse(): object {
      return eventDelegatorFactory(this, 'show', 'shown', 'hide', 'hidden')
    },
    uniqueId(): string {
      if (this.id != null) {
        return this.id
      } else {
        return `collapsible-${++idSequence}`
      }
    },
  },
  data(): { showCollapse: boolean } {
    return { showCollapse: this.visible }
  },
  watch: {
    showCollapse(nowIs: boolean, was: boolean) {
      if (nowIs !== was) {
        this.$emit('update:visible', nowIs)
      }
    },
    visible(nowIs: boolean, was: boolean) {
      if (nowIs !== was) {
        this.showCollapse = nowIs
      }
    },
  },
})
